import { render, staticRenderFns } from "./BranchEditor.vue?vue&type=template&id=2e833f62&scoped=true&"
import script from "./BranchEditor.vue?vue&type=script&lang=ts&"
export * from "./BranchEditor.vue?vue&type=script&lang=ts&"
import style0 from "./BranchEditor.vue?vue&type=style&index=0&id=2e833f62&lang=scss&scoped=true&"
import style1 from "./BranchEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e833f62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
